import { all, takeEvery, put, select, call } from 'redux-saga/effects';
import { FirebaseError } from 'firebase/app';

import { fetchUserInfo, fetchUserUsage } from 'features/Auth/actions';
import { setInitialAuthDone, setFirebaseAuthenticated } from 'features/Auth/slice';
import { TRootState } from 'store';
import { authClient } from 'utils/capawesomeAuth';
import { ERROR_MESSAGES } from 'utils/constants';

import { SUBMIT_LOGIN_FORM } from './actionTypes';
import { getEmail, getPassword } from './selectors';
import { setLoading, setError, resetState as resetLoginState } from './slice';

function* loginFormSubmitSaga() {
  const state: TRootState = yield select();

  const email = getEmail(state);
  const password = getPassword(state);

  if (!email) {
    return;
  }

  if (!password) {
    return;
  }

  yield put(setLoading(true));
  yield put(setError(''));

  try {
    yield call([authClient, authClient.signInWithEmailAndPassword], { email, password });
    yield put(setFirebaseAuthenticated(true));

    yield put(fetchUserInfo());
    yield put(fetchUserUsage());

    yield put(setInitialAuthDone(true));
    yield put(resetLoginState());
  } catch (error: unknown) {
    let errorMessage = ERROR_MESSAGES.WRONG_EMAIL_PASS;
    if (error instanceof FirebaseError) {
      switch (error.code) {
        case 'auth/wrong-password':
        case 'auth/user-not-found':
        case 'auth/invalid-credential':
          errorMessage = ERROR_MESSAGES.WRONG_EMAIL_PASS;
          break;
        case 'auth/too-many-requests':
          errorMessage = 'Too many failed login attempts. Please try again later.';
          break;
        case 'auth/user-disabled':
          errorMessage = 'This account has been disabled.';
          break;
        default:
          errorMessage = ERROR_MESSAGES.SOMETHING_WENT_WRONG;
      }
    }

    yield put(setError(errorMessage));
    yield put(setLoading(false));
  }
}

export function* watchLoginForm() {
  yield all([takeEvery(SUBMIT_LOGIN_FORM, loginFormSubmitSaga)]);
}
